import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ChipModule } from '@commons/chip/chip.component';
import { ExternalLinkDirectiveModule } from '@commons/directives/external-link/external-link.directive';
import { EllipsisPipeModule } from '@commons/pipes/ellipsis/ellipsis.pipe';
import { Schedule, ScheduleModule } from '@commons/schedule/schedule.component';
import { YouthInfoCenterSchedule, YouthInfoCenterScheduleHour } from '@models/youth-info-center/youth-info-center';
import { trackEventWithAtInternet } from '@wizbii/tracking';

@Component({
  selector: 'app-youth-info-center-card-details',
  templateUrl: './youth-info-center-card-details.component.html',
  styleUrls: ['./youth-info-center-card-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class YouthInfoCenterCardDetailsComponent {
  @Input() phone!: string;
  @Input() email!: string;
  @Input() url!: string;
  @Input() name!: string;
  @Input() schedules!: YouthInfoCenterSchedule[];

  trackEvent = trackEventWithAtInternet;
  get parsedSchedules(): Schedule[] {
    return this.transformSchedules(this.schedules);
  }

  transformSchedules(schedules: YouthInfoCenterSchedule[]): Schedule[] {
    const res = [];
    const days = ['lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi', 'dimanche'];

    for (let i = 0; i < schedules.length; i++) {
      const schedule = schedules[i];
      if (schedule.from === schedule.to) {
        res.push({
          label: schedule.from,
          hours: this.transformScheduleHours(schedule.hourRanges),
        });
      } else {
        let day = schedule.from;
        const hours = this.transformScheduleHours(schedule.hourRanges);
        while (day !== schedule.to) {
          res.push({
            label: day,
            hours,
          });
          day = days[days.indexOf(day) + 1];
        }
        res.push({
          label: schedule.to,
          hours,
        });
      }
    }

    return res.sort(this.sortByDayOfWeek);
  }

  sortByDayOfWeek(day1: Schedule, day2: Schedule): number {
    const sorter: Record<string, number> = {
      lundi: 1,
      mardi: 2,
      mercredi: 3,
      jeudi: 4,
      vendredi: 5,
      samedi: 6,
      dimanche: 7,
    };

    const d1 = day1.label.toLowerCase();
    const d2 = day2.label.toLowerCase();

    return sorter[d1] - sorter[d2];
  }

  transformScheduleHours(hours: YouthInfoCenterScheduleHour[]): YouthInfoCenterScheduleHour[] {
    return hours.map(({ from, to }) => ({
      from: from.slice(0, 5).split(':').join('h'),
      to: to.slice(0, 5).split(':').join('h'),
    }));
  }
}

@NgModule({
  imports: [CommonModule, ChipModule, MatIconModule, ScheduleModule, ExternalLinkDirectiveModule, EllipsisPipeModule],
  declarations: [YouthInfoCenterCardDetailsComponent],
  exports: [YouthInfoCenterCardDetailsComponent],
})
export class YouthInfoCenterCardDetailsModule {}
